import * as React from "react";

import "./intelligent-mail-barcode.scss";

import {XdSentry}       from "@Common/libs/sentry/xd-sentry";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";
import {BubbleNoti}     from "@Common/ui-components/bubble-noti/bubble-noti";

import {MultiInputModal} from "../multi-input-modal/multi-input-modal";

export const IntelligentMailBarcode = ({apis=undefined, next}) => cs(

    ["apis", (_, next) => apis ? (
        next(apis)
    ) : cs(
        consumeContext("apis"),
        ({apis}) => next({
            getMailerId: () => apis.next.imb.getMailerId(),
            saveMailerId: ({idMailer, idPrimary}) => apis.next.imb.saveMailerId({
                idMailer,
                idPrimary,
            }),
        })
    )],
    consumeContext("company"),
    consumeContext("session"),
    ["mailerActive", ({company, session}, next) => next(
        !company?.prefs?.dynamicAccount ||
        session?.data?.agent?.activeAddressableOrMailableTemplate
    )],
    ["mailerId", ({apis, mailerActive}, next) => Load2({
        _key: !!mailerActive,
        fetch: () => !mailerActive ? null : apis.getMailerId(),
        next,
    })],

    ({apis, mailerActive, mailerId}) => next(mailerActive && {
        render: ({next}) => cs(
            ["loading", (_, next) => UseState({
                initValue: false,
                next
            })],
            ["bubbleNoti", (_, next) => BubbleNoti({next})],
            ["editBarcodeModal", ({loading, bubbleNoti}, next) => MultiInputModal({
                next,
                title: "Intelligent Mail Barcode",
                labelLocation: "top",
                onSave: async (updateBarcodeFields) => {
                    if(isNaN(Number(updateBarcodeFields.mailerId)) || updateBarcodeFields.mailerId.length < 6) {
                        return {
                            errorInfo: '[{"mapping": "mailerId", "message": "The Mailer ID you provided is invalid. Values must be numeric and between 6 to 9 characters in length."}]'
                        }
                    } else if (updateBarcodeFields.mailerId !== updateBarcodeFields.confirmMailerId) {
                        return {
                            errorInfo: '[{"mapping": "confirmMailerId", "message": "Confirm Mailer ID field must match the Mailer ID field."}]'
                        }
                    } else {
                        try {
                            const result = await apis.saveMailerId({
                                idMailer: updateBarcodeFields.mailerId,
                                idPrimary: mailerId?.value?.idPrimary ?? 0
                            });
                            bubbleNoti.show({
                                message: `Success! Intelligent mail barcode successfully ${mailerId?.value?.idPrimary ? 'updated' : 'added'}.`,
                                color: "green",
                            });
                            return result;
                        } catch (error) {
                            if ((typeof error)=="string") {
                                return {errorMessage: error};
                            } else {
                                XdSentry.captureException(error);
                                return {errorMessage: "An unexpected error occurred."};
                            }
                        }
                    }
                },
                reload: async () => {
                    loading.onChange(true);
                    await mailerId?.reload();
                    loading.onChange(false);
                },
            })],
            ({loading, editBarcodeModal}) => next({
                header: {
                    title: "Manage Intelligent Mail Barcode",
                    subtitle: "You can use this information on product customization.",
                    action: {
                        xdQaName: mailerId?.value?.idMailer || loading.value || mailerId?.loading ? "Edit IMB" : "Add IMB",
                        label: mailerId?.value?.idMailer || loading.value || mailerId?.loading ? "Edit" : "Add",
                        onClick: () => editBarcodeModal.show({
                            data: [
                                {"label": <div xd-qa-type="label" xd-qa-name="Mailer ID">Mailer ID <span style={{color: "red"}}>*</span></div>, "value": String(mailerId?.value?.idMailer ?? ""), "mapping": "mailerId", "maxLength": 9},
                                {"label": <div xd-qa-type="label" xd-qa-name="Confirm Mailer ID">Confirm Mailer ID <span style={{color: "red"}}>*</span></div>, "value": "", "mapping": "confirmMailerId", "maxLength": 9},
                            ],
                        }),
                    },
                },
                content: (
                    <div className="intelligent-mail-barcode-8s3">

                        {loading.value || mailerId?.loading ? (
                            <div className="loading">
                                <i className="fa fa-spinner fa-pulse"/>
                            </div>
                        ) : (
                            !mailerId?.value?.idMailer ? (
                                <div className="item">
                                    <div className="value" xd-qa-type="label" xd-qa-name="No Mailer ID">
                                        You do not have a Mailer ID on file.
                                    </div>
                                    <a
                                        className="link"
                                        target="_blank"
                                        href={"https://pe.usps.com/text/DMM300/204.htm"}
                                        xd-qa-type="link"
                                        xd-qa-name="Learn More"
                                    >
                                        Learn More
                                    </a>
                                </div>
                            ) : (
                                <div className="item">
                                    <div className="subtitle" xd-qa-type="label" xd-qa-name="Mailer Id on File">
                                        Mailer ID on File
                                    </div>
                                    <div className="value" xd-qa-type="label" xd-qa-name="Mailer ID">
                                        {mailerId?.value?.idMailer}
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                ),
            }),
        ),
    })
);
